import React from "react";
import lax from "lax.js";
import Footer from "../Common/Footer";
import Partner from "../Common/Partner";
import { expositores } from "../DataFiles/expositores";
import { colaboradores } from "../DataFiles/colaboradores";

class Sponsor extends React.Component {
  constructor(props) {
    super(props);
    lax.setup();

    document.addEventListener(
      "scroll",
      function (x) {
        lax.update(window.scrollY);
      },
      false
    );

    lax.update(window.scrollY);
  }
  render() {
    return (
      <React.Fragment>
        <div className="page-title-area item-bg1">
          <div className="container">
            <h1>Patrocinadores</h1>
            <span>
              Este congreso es posible gracias al apoyo de nuestros
              patrocinadores.
            </span>
          </div>
        </div>

        <section className="partner-area ptb-120">
          <div className="container">
            <Partner />

            <div className="row">
              <div className="col-lg-12">
                <div className="border"></div>
              </div>

              <div className="col-lg-12">
                <div className="partner-title gold-sponsor">
                  <h3 className="lax" data-lax-preset="driftLeft">
                    Expositores
                  </h3>
                </div>
              </div>

              {expositores.map((expositor) => (
                <div className="col-lg-4 col-md-4 col-6">
                  <div className="partner-item">
                    <img src={expositor.logo} alt="sponsor" />
                  </div>
                </div>
              ))}
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="border"></div>
              </div>

              <div className="col-lg-12">
                <div className="partner-title gold-sponsor">
                  <h3 className="lax" data-lax-preset="driftLeft">
                    Colaboradores
                  </h3>
                </div>
              </div>

              {colaboradores.map((colaborador) => (
                <div className="col-lg-3 col-md-4 col-6">
                  <div className="partner-item">
                    <img src={colaborador.logo} alt="sponsor" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <Footer />
      </React.Fragment>
    );
  }
}

export default Sponsor;
